<template>
  <v-autocomplete
    label="Site"
    v-model="site"
    @update:model-value="clearErrors()"
    :items="sites"
    item-value="code"
    :item-title="(item) => `${item.code} - ${item.name ? item.name : item.address.address1}`"
    :loading="loading"
    :disabled="disabled || disableOnEmptySiteList"
    :error-messages="error && error.message"
    v-bind="$attrs"
  >
    <template #append-item v-if="allowSiteCreation">
      <DropdownListItemAction
        :search="search"
        :keep-enabled="true"
        @click="emit('create-site-pressed')"
        label="Create Site"
      />
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ISiteData } from '@/models/client'

import { useFetchSites } from '@/composables/site'

import DropdownListItemAction from '@/components/common/DropdownListItemAction.vue'

interface Props {
  client: number | null
  disabled?: boolean
  disableOnEmptySiteList?: boolean
  allowSiteCreation?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  client: null,
  allowSiteCreation: false
})

const emit = defineEmits<{
  (e: 'create-site-pressed'): void
}>()

const site = defineModel<null | ISiteData | number>({ default: null })
const search = defineModel<string>('search', { default: '' })

const clientId = computed(() => props.client!)
const { sites, isLoading: loading, error } = useFetchSites(clientId)

const disableOnEmptySiteList = computed(
  () => props.disableOnEmptySiteList && sites.value?.length === 0
)

function clearErrors() {
  error.value = null
}
</script>
